export const techniciansList = "TECHNICIANS_LIST";
export const regionList = "REGION_LIST";
export const specializationList = "SPECIALIZATION_LIST";
export const allTechnicians = "ALL_TECHNICIANS_LIST"